import { createAction, props } from '@ngrx/store';

import {
  ChargerActivityResponseStoreModel,
  ChargerActivityWebsocketMessageStoreModel,
  ChargingTimelineResponseStoreModel,
  ChargingTimelineWebsocketMessageStoreModel,
  EvseActivityResponseStoreModel,
  EvseActivityWebsocketMessageStoreModel,
} from '@domain/charger-details/charger-details.models';

export const loadChargerActivity = createAction('[Single site charger details] load charger activity');
export const loadChargerActivitySuccess = createAction(
  '[Single site charger details] load charger activity success',
  props<{ chargerActivity: ChargerActivityResponseStoreModel }>()
);
export const loadChargerActivityFailure = createAction(
  '[Single site charger details] load charger activity failure',
  props<{ error: string }>()
);
export const initEvseDetailsEffectsFinished = createAction('[Single site charger details] init evse details effects finished');

export const chargerActivitySocketMessageArrive = createAction(
  '[Single site charger details] charger activity socket message arrive',
  props<{ message: ChargerActivityWebsocketMessageStoreModel }>()
);

export const loadEvseActivity = createAction('[Single site charger details] load evse activity', props<{ evseId: string }>());
export const loadEvseActivitySuccess = createAction(
  '[Single site charger details] load evse activity success',
  props<{ evseActivity: EvseActivityResponseStoreModel; evseId: string }>()
);
export const loadEvseActivityFailure = createAction(
  '[Single site charger details] load evse activity failure',
  props<{ error: string; evseId: string }>()
);
export const evseActivitySocketMessageArrive = createAction(
  '[Single site charger details] evse activity socket message arrive',
  props<{ message: EvseActivityWebsocketMessageStoreModel; evseId: string }>()
);

export const loadChargerActivityTimeline = createAction(
  '[Single site charger details] load charger activity timeline',
  props<{ beforeTime?: string }>()
);
export const loadChargerActivityTimelineSuccess = createAction(
  '[Single site charger details] load charger activity timeline success',
  props<{ chargerActivityTimeline: ChargingTimelineResponseStoreModel; requestedBeforeTime?: string }>()
);
export const loadChargerActivityTimelineFailure = createAction(
  '[Single site charger details] load charger activity timeline failure',
  props<{ error: string }>()
);
export const loadNextChargerActivityTimelinePage = createAction('[Single site charger details] load next charger activity timeline page');

export const chargerActivityTimelineSocketMessageArrive = createAction(
  '[Single site charger details] charger activity timeline socket message arrive',
  props<{ message: ChargingTimelineWebsocketMessageStoreModel }>()
);

export const loadEvseActivityTimeline = createAction(
  '[Single site charger details] load evse activity timeline',
  props<{ evseId: string; beforeTime?: string }>()
);
export const loadEvseActivityTimelineSuccess = createAction(
  '[Single site charger details] load evse activity timeline success',
  props<{ evseId: string; evseActivityTimeline: ChargingTimelineResponseStoreModel; requestedBeforeTime?: string }>()
);
export const loadEvseActivityTimelineFailure = createAction(
  '[Single site charger details] load evse activity timeline failure',
  props<{ evseId: string; error: string }>()
);
export const loadNextEvseActivityTimelinePage = createAction(
  '[Single site charger details] load next evse activity timeline page',
  props<{ evseId: string }>()
);

export const evseActivityTimelineSocketMessageArrive = createAction(
  '[Single site charger details] evse activity timeline socket message arrive',
  props<{ evseId: string; message: ChargingTimelineWebsocketMessageStoreModel }>()
);

export const clearSingleSiteChargerDetailsData = createAction('[Single site charger details] clear single site charger details data');
